import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const StyledTitle = styled(({ ...props }: any) => <Typography {...props} />)(
    () => ({
        fontSize: '20px',
        fontWeight: 'bold',
        lineHeight: '130%',
        color: '#2B3445',
    })
);

export default StyledTitle;
